import { Check } from '@phosphor-icons/react'

export type WorkflowStep = 1 | 2 | 3 | 4

const steps: ReadonlyArray<{ id: WorkflowStep; label: string; detail: string }> = [
  { id: 1, label: '导入文件', detail: '基准版与对比版' },
  { id: 2, label: '工作表与字段', detail: '独立确认映射' },
  { id: 3, label: '处理待确认', detail: '核对模糊候选' },
  { id: 4, label: '结果与导出', detail: '筛选并生成报告' },
]

interface StepRailProps {
  current: WorkflowStep
  maxReached: WorkflowStep
  onStepChange: (step: WorkflowStep) => void
}

export function StepRail({ current, maxReached, onStepChange }: StepRailProps) {
  return (
    <nav className="step-rail" aria-label="对比流程">
      <ol>
        {steps.map((step) => {
          const complete = step.id < current
          const available = step.id <= maxReached
          return (
            <li key={step.id} data-active={current === step.id} data-complete={complete}>
              <button
                type="button"
                disabled={!available}
                onClick={() => onStepChange(step.id)}
                aria-current={current === step.id ? 'step' : undefined}
              >
                <span className="step-rail__index" aria-hidden="true">
                  {complete ? <Check weight="bold" /> : step.id}
                </span>
                <span>
                  <strong>{step.label}</strong>
                  <small>{step.detail}</small>
                </span>
              </button>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
